import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const getDiscountPercentage = (discount: number | undefined, listPrice: number) => {
    if (!discount) {
        return undefined;
    }

    const discountPercentage = ga.util.parseAmount((discount / listPrice) * 100) || 0;

    return discountPercentage <= 0 ? undefined : discountPercentage;
};

export default getDiscountPercentage;
